<template>
  <v-container>
    <v-btn
      text
      @click="$router.push('/dashboard')"
    >&leftarrow; Back to dashboard</v-btn>
    <v-banner
      v-if="orderStatus === 'unpaid'"
      sticky
      color="background"
    >
      <div class="d-flex flex-row justify-space-between">
        <span class="text-h6">{{capitaliseFirstLetter(this.orderType)}} order</span>
        <div class="d-flex flex-row">
          <div class="mr-2">
            <span class="text-caption">Status: </span><br />
            <span
              class="text-uppercase font-weight-bold"
              style="color:#F5AC37"
            >{{ isValidWithinTime ? orderStatus : 'pending' }}</span>
          </div>
          <div class="ml-2">
            <span class="text-caption">Valid for: </span> <br />
            <CountdownTimer
              :endDate="expirationTime"
              @endTime="handleTimeExpired"
              typography="font-weight-bold text-body-1"
            />
          </div>
        </div>
      </div>
    </v-banner>
    <OrderUnpaid
      v-if="orderStatus === 'unpaid'"
      :orderType="orderType"
      :orderStatus="orderStatus"
      :isValidWithinTime="isValidWithinTime"
    />
    <OrderPaid
      v-if="orderStatus === 'paid'"
      :orderType="orderType"
      :orderStatus="orderStatus"
    />
    <OrderInvalid
      v-if="orderStatus === 'invalid'"
      :orderType="orderType"
      :orderStatus="orderStatus"
    />
  </v-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import OrderUnpaid from '../../components/order/OrderUnpaid.vue'
import OrderPaid from '../../components/order/OrderPaid.vue'
import OrderInvalid from '../../components/order/OrderInvalid.vue'
import CountdownTimer from "../../components/CountdownTimer.vue"
import { utilsMixin } from '../../mixins/utilsMixin.js'

export default {
  props: ["orderType"],
  mixins: [utilsMixin],
  components: {
    OrderUnpaid,
    OrderPaid,
    OrderInvalid,
    CountdownTimer,
  },
  data() {
    return {
      orderStatus: 'unpaid',
      isValidWithinTime: true,
    }
  },
  computed: {
    ...mapState('order', ['order']),
    ...mapState("auth", ["accessToken"]),
    orderConfirmedAt() {
      if (this.order) {
        return new Date(JSON.parse(this.order.confirmedAt))
      }
    },
    expirationTime() {
      if (this.order) {
        return new Date(this.orderConfirmedAt.getTime() + 5 * 60000);
      }
    }
  },
  methods: {
    ...mapMutations('order', ['setOrder']),
    ...mapMutations('utils', ['setIsLoadingOverlay']),
    ...mapActions("auth", ["getAccessToken"]),
    handleTimeExpired() {
      this.isValidWithinTime = false
      window.scrollTo(0, 0)
    }
  },
  async mounted() {
    this.setIsLoadingOverlay(true)
    try {
      await this.getAccessToken()
      const id = this.$route.params.id
      const response = await fetch(`${process.env.VUE_APP_API_URL}/orders/${id}`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.accessToken}`,
        },
      })
      const data = await response.json()
      this.isValidWithinTime = data.validAtLastGet
      this.orderStatus = data.status
      await this.setOrder(data)
    } catch (error) {
      console.log(error)
    }
    this.$nextTick(() => {
      this.setIsLoadingOverlay(false)
    })
  },
}
</script>
